/** Em dash shown in read-only UI where a value is missing or empty. */
export const EMPTY_VALUE_PLACEHOLDER = "—";
